export default {
  newDesign: true,
  title: "7 soruyu yanıtlayın ve süperstar öğretmenimizle ücretsiz matematik seansı için kaydolun!",
  downtimeUrl: "https://www.kodland.org/tr",
  parameters: {
    landing_id: "MathWQ",
    segment: 39,
  },
  startPage: {
    title:
      "7 soruyu yanıtlayın ve süperstar öğretmenimizle ücretsiz matematik seansı için kaydolun!",
    subtitle:
      "Kayıt sadece 2 dakika sürer. Ders küçük bir grupla yapılacaktır. Size uygun bir gün ve saat seçebilirsiniz.",
    image: {
      url: "/welcome/math_gtc_desktop2.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/math_gtc_mob2.png",
      style: {
        width: "100%",
      },
    },
    button: " Başla! ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuz şu anda hangi sınıfta?",
      answers: [
        "◀️ 5. sınıfın altında",
        "5️⃣ 5. sınıf",
        "6️⃣ 6. sınıf",
        "7️⃣ 7. sınıf",
        "8️⃣ 8. sınıf",
        "▶️ 8. sınıf üstü"
      ],
    },
    2: {
      question: "Çocuğunuzun okuldaki matematik eğitimi konusunda ne kadar memnunsunuz?",
      answers: [
        "☹️ Hiç memnun değilim",
        "👌 Bazı zorluklar var ama çoğunlukla iyi",
        "🙂 Genelde memnunum",
        "🤩 Çocuğumun matematik deneyiminden çok mutluyum"
      ],
    },
    3: {
      question: "Çocuğunuzun okulda aldığı ortalama notlar nedir?",
      answers: [
        "🌟 85-100 | Pekiyi",
        "👍 70-84 = İyi",
        "🆗 60-69 = Orta",
        "☹️ 50-59 = Geçer",
        "👎 0-49 = Başarısız"
      ],
    },
    4: {
      question: "Çocuğunuz “yeni nesil” matematik soruları hakkında nasıl hissediyor? (LGS’de kullanılan)",
      answers: [
        "🤩 Bu tür sorularda rahat",
        "🤔 Gördüler ama zorlanıyor",
        "😨 Yeni nesil sorulardan korkuyor ve kaçınıyor",
        "🤷‍♀️ Bu sorular hakkında bilgim yok"
      ],
    },
    5: {
      question: "Çocuğunuzun matematikle ilgili ana zorlukları nelerdir?",
      answers: [
        "🎒 Müfredatla başa çıkma",
        "😨 Anlama ve özgüven sorunları",
        "📝 Sınav hazırlığı",
        "😊 Daha fazla destek ihtiyacı"
      ],
    },
    6: {
      question: "Çocuğunuz matematik hakkında ne düşünüyor?",
      answers: [
        "🤔 Meraklı ama zorlanıyor",
        "🤯 Kaçınma eğiliminde",
        "💪 Güvenli ama sınav yardımı lazım",
        "😊 Matematiği seviyor, çoğunu anlıyor"
      ],
    },
    7: {
      question: "Ek matematik desteği istemenizin sebebi nedir?",
      answers: [
        "🗣️ Özgüven ve keyif kazanmak",
        "📐 Notları iyileştirmek",
        "👍 LGS başarısı",
        "🌟 Matematiği eğlenceli hale getirmek"
      ],
    },
    8: {
      question:
        "Çocuğunuzun çalışabileceği bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "💻 Evet",
        {
          answer: "☹️ Hayir",
          stopAnswer: true,
        },
      ],
    },
    9: {
      title: "Çocuğunuz kaç yaşında?",
      subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz.",
      type: "age",
      button: "",
    },
    10: {
      title: "Tebrikler! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Kaydı tamamlamak için '📆 Rezervasyon yapın' seçeneğine tıklayın.",
      button: "📆 Rezervasyon yapın",
    },
    11: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    12: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    13: {
      title:
        "Teşekkürler! Ücretsiz deneme dersiniz başarıyla planlandı. 🎉",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    14: {
      title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    15: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    }
  },
};
